import React from 'react';

const Privacy: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4 bg-gray-50">
        <div className="container mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl font-bold mb-6">Datenschutz</h1>
            <p className="text-gray-600 text-lg">
              Informationen zum Schutz Ihrer persönlichen Daten.
            </p>
          </div>
        </div>
      </section>
      
      {/* Privacy Content */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-3xl">
          <div className="prose prose-lg max-w-none">
            <h2>Datenschutzerklärung</h2>
            <p>
              Der Schutz Ihrer Privatsphäre ist für uns sehr wichtig. Nachstehend informieren wir Sie ausführlich über den Umgang mit Ihren Daten.
            </p>
            <br></br>
            <h3>1. Verantwortliche Stelle</h3>
            <p>
              A.B.S. GmbH - Gebäudesanierung und Renovierung <br />
              Talweg 2G<br />
              85614 Kirchseeon<br />
              Tel.: +49 17657122695
            </p>
            <br></br>
            <h3>2. Erhebung und Verarbeitung personenbezogener Daten</h3>
            <p>
              Personenbezogene Daten sind Informationen, die dazu genutzt werden können, Ihre Identität zu erfahren. Darunter fallen Informationen wie Ihr richtiger Name, Adresse, Postanschrift, Telefonnummer. Informationen, die nicht mit Ihrer Identität in Verbindung gebracht werden (wie zum Beispiel Anzahl der Nutzer einer Website), gehören nicht dazu.
            </p>
            <p>
              Sie können unser Online-Angebot grundsätzlich ohne Offenlegung Ihrer Identität nutzen. Wenn Sie bei uns einen Termin vereinbaren oder den Newsletter bestellen, fragen wir Sie nach Ihrem Namen und nach anderen persönlichen Informationen. Es unterliegt Ihrer freien Entscheidung, ob Sie diese Daten eingeben.
            </p>
            <p>
              Ihre Angaben speichern wir auf besonders geschützten Servern in Deutschland. Der Zugriff darauf ist nur wenigen besonders befugten Personen möglich, die mit der technischen, kaufmännischen oder redaktionellen Betreuung dieser Server befasst sind.
            </p>
            <br></br>
            <h3>3. Datensicherheit</h3>
            <p>
              Wir sichern unsere Website und sonstigen Systeme durch technische und organisatorische Maßnahmen gegen Verlust, Zerstörung, Zugriff, Veränderung oder Verbreitung Ihrer Daten durch unbefugte Personen. Der Zugang zu Ihrem Kundenkonto ist nur nach Eingabe Ihres persönlichen Passwortes möglich.
            </p>
            <br></br>
            <h3>4. Auskunftsrecht</h3>
            <p>
              Auf Anforderung teilen wir Ihnen schriftlich entsprechend dem geltenden Recht mit, ob und welche persönlichen Daten über Sie bei uns gespeichert sind. Sie haben zudem das Recht auf Berichtigung, Sperrung oder Löschung Ihrer Daten im Rahmen der gesetzlichen Bestimmungen.
            </p>
            <br></br>
            <h3>5. Änderungen dieser Datenschutzerklärung</h3>
            <p>
              Wir behalten uns das Recht vor, diese Datenschutzerklärung jederzeit unter Beachtung der geltenden Datenschutzvorschriften zu ändern.
            </p>
            <br></br>
            <p>Stand: Januar 2026</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;